import React from 'react';
import TriangleDown from '../../asset/TriangleDown';
import VideoMockup from './VideoMockup';

// image grid uses image tags
// first -- url for image
// style -- for color theme
const VideoGridx1 = ({first, themeColor, showTriangle, innerDescription, vidcaption, extra}) => (
  <section>
    <div className="grid" style={{backgroundColor: themeColor,}}>
      <div className="container">
        {showTriangle ? <TriangleDown style={{fill: themeColor}}/> : null}
        {innerDescription !== undefined
          ? <div>{innerDescription} </div>
          : null}

        <div className="video-wrap">
          <div className="hero-vid">
            <VideoMockup video={first} caption={vidcaption}/>
          </div>
        </div>
      </div>
    </div>

    {extra !== undefined
      ? <div className="grid"  style={{backgroundColor: themeColor,}}>
          <div className="container extra-padding-bottom">
              <div className="wrap">
                {extra}
              </div>
          </div>
        </div>
      : null }

  </section>
);


export default VideoGridx1;



// WEBPACK FOOTER //
// ./src/layout/portfolio/VideoGridx1.js